<template>
  <v-navigation-drawer
    :value="value"
    right
    temporary
    fixed
    width="848"
    role="dialog"
    aria-modal="true"
    aria-labelledby="gg-drawer-engine-title"
    class="gg-idrawer"
    @input="$emit('input', $event)"
  >
    <div class="gg-idrawer__header">
      <h2 id="gg-drawer-engine-title" class="gg-idrawer__title">Cadastrar novo engine</h2>
      <button type="button" class="gg-idrawer__close" aria-label="Fechar" @click="close">
        <v-icon size="24">mdi-close</v-icon>
      </button>
    </div>

    <div class="gg-idrawer__body gg-drawer-form">
      <div class="gg-form-block">
        <div class="gg-field">
          <label class="gg-field__label" for="gg-engine-key">
            Key<span class="gg-field__required" aria-hidden="true">*</span>
          </label>
          <!-- The key is the engine's stable identifier (MSE output name, playlist
               binding), so it is set once here and never editable afterwards. -->
          <input
            id="gg-engine-key"
            v-model="key"
            type="text"
            class="gg-field__input"
            placeholder="main"
            required
          />
        </div>

        <div class="gg-field">
          <label class="gg-field__label" for="gg-engine-nome">Nome (opcional)</label>
          <input
            id="gg-engine-nome"
            v-model="nome"
            type="text"
            class="gg-field__input"
            placeholder="São Paulo / SP"
          />
        </div>

        <div class="gg-field">
          <label class="gg-field__label" for="gg-engine-host">
            Host<span class="gg-field__required" aria-hidden="true">*</span>
          </label>
          <input
            id="gg-engine-host"
            v-model="host"
            type="text"
            class="gg-field__input"
            placeholder="10.193.150.114"
            required
          />
        </div>

        <div class="gg-field-row">
          <div class="gg-field">
            <label class="gg-field__label" for="gg-engine-port">
              Porta<span class="gg-field__required" aria-hidden="true">*</span>
            </label>
            <input
              id="gg-engine-port"
              v-model.number="port"
              type="number"
              class="gg-field__input"
              placeholder="6800"
              required
            />
          </div>
          <div class="gg-field">
            <label class="gg-field__label" for="gg-engine-webrtc-port">
              WebRTC Porta<span class="gg-field__required" aria-hidden="true">*</span>
            </label>
            <input
              id="gg-engine-webrtc-port"
              v-model.number="webrtcPort"
              type="number"
              class="gg-field__input"
              placeholder="9092"
              required
            />
          </div>
        </div>

        <div class="gg-switch-field">
          <v-switch v-model="active" label="Ativo" hide-details dense class="gg-switch mt-0 pt-0" />
        </div>
      </div>
    </div>

    <div class="gg-idrawer__footer">
      <button type="button" class="gg-idrawer__submit" :disabled="!canSave" @click="save">
        {{ saving ? 'Salvando…' : 'Salvar' }}
      </button>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from "vuex";
import ggDrawerA11y from "@/mixins/ggDrawerA11y";

export default {
  name: "GloboGraphicsEngineFormDrawer",
  mixins: [ggDrawerA11y],
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      key: "",
      nome: "",
      host: "",
      port: null,
      webrtcPort: null,
      active: true,
      saving: false,
    };
  },
  computed: {
    canSave() {
      return !!(this.key.trim() && this.host.trim() && this.port && this.webrtcPort && !this.saving);
    },
  },
  watch: {
    // The drawer stays mounted across open/close, so seed on every open —
    // otherwise a cancelled draft reappears next time.
    value(open) {
      if (open) this.reset();
    },
  },
  methods: {
    ...mapActions("playout_engines", ["createEngine"]),
    reset() {
      this.key = "";
      this.nome = "";
      this.host = "";
      this.port = null;
      this.webrtcPort = null;
      this.active = true;
    },
    close() {
      this.$emit("input", false);
    },
    async save() {
      if (!this.canSave) return;
      this.saving = true;
      try {
        await this.createEngine({
          key: this.key.trim(),
          nome: this.nome.trim(),
          host: this.host.trim(),
          port: this.port,
          webrtcPort: this.webrtcPort,
          active: this.active,
        });
        this.$emit("created");
        this.$toast?.success?.("Engine criado");
        this.close();
      } catch (e) {
        this.$toast?.error?.(e?.response?.data?.error || "Erro ao criar engine");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
